<template>
	<select
		class="select"
		:id="id"
		:class="{ 'select--small': small }"
		:value="value"
		@change="handleChange"
	>
		<slot></slot>
	</select>
</template>

<script>
export default {
	props: {
		value: {},
		small: {
			type: Boolean,
			default: false
		},
		id: {
			type: String
		}
	},
	methods: {
		handleChange(evt) {
			this.$emit("input", evt.target.value);
		}
	}
};
</script>

<style lang="scss" scoped>
.select {
	width: 100%;
	appearance: none;
	background-color: $white;
	background-image: url("data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJjYXJldC1kb3duIiBjbGFzcz0ic3ZnLWlubGluZS0tZmEgZmEtY2FyZXQtZG93biBmYS13LTEwIiByb2xlPSJpbWciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDMyMCA1MTIiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTMxLjMgMTkyaDI1Ny4zYzE3LjggMCAyNi43IDIxLjUgMTQuMSAzNC4xTDE3NC4xIDM1NC44Yy03LjggNy44LTIwLjUgNy44LTI4LjMgMEwxNy4yIDIyNi4xQzQuNiAyMTMuNSAxMy41IDE5MiAzMS4zIDE5MnoiPjwvcGF0aD48L3N2Zz4=");
	background-position: center right 16px;
	background-size: 16px;
	background-repeat: no-repeat;
	border-radius: 4px;
	padding: 16px;
	font-family: $font-family;
	font-size: 18px;
	border: none;
	box-shadow: 0 1px 2px 0 rgba(51, 66, 66, 0.09);

	&--small {
		font-size: 16px;
		padding: 12px;
		background-position: center right 12px;
		background-size: 10px;
	}

	&::before {
		content: "";
		width: 20px;
		height: 20px;
		background-image: url(../../icons/select-down.svg);
	}
}
</style>